export default {
  "news": {
    "title": "News",
    "learn_more": "Learn more",
    "back_to_home": "Back to Home",
    "not_found": "News not found"
  }
}
